import { propPanelMixin } from '../../../helpers';
import isEqual from "lodash-es/isEqual";
import pickBy from "lodash-es/pickBy";
import isEmpty from "lodash-es/isEmpty";
import { getHashValue, getInternalClassNames } from './utils/func';
import "./css/index.css";
import SPPosition from './comps/position';
import SPBorder from './comps/Border/border';
import SPCssBox from './comps/cssBox';
// import SPDisplay from './comps/display';
import SPOverflow from './comps/overflow';
import WAccordion from '../../../builtin/components/Accordion';
import SPHover from './comps/hover';
import SPEffects from './comps/effects';
import NewBackground from './comps/Background';
import NewFontStyle from './comps/FontStyle';
import { vueLinkStorageWithDefaultObjectValue } from "../../../../lib/utils/vue/vueLinkStorageWithDefaultValue";
import { UCStyleSheetType, validStyleSheet } from '../../../utils/ucCssGenerator';
import { uuidv4 } from '../../../utils';
import DiyClassName from './comps/diyClassName';
import { CSSSelector } from './comps/CSSSelector';
import { PanelStateCssEditor } from './comps/PanelStateCssEditor';
import { getStyleAfterUnitCompletion } from './utils/styleUtils';
import { highlightRect } from "../../../../lib/utils/browser/highlightRect";
import { cloneDeep } from "lodash-es";
import { StyleTemplagePanel } from './comps/StyleTemplate/StyleTemplatePanel';
import { CssEditorList } from './comps/PanelStateCssEditor/CssEditorList';
const __script_base__ = {
  name: 'StylePanel',
  mixins: [propPanelMixin],
  props: ['showPanelName'],
  data() {
    return {
      hoverStyle: {},
      panelExpanded: {
        css: false,
        layoutBox: true,
        preference: true,
        fontStyle: true,
        background: false,
        detail: false,
        layout: false,
        hover: false,
        advanced: false
      },
      previewType: 'static',
      cssEditorTabs: [{
        id: 'static',
        label: 'static'
      }, {
        id: 'hover',
        label: 'hover'
      }],
      diyCssHelpText: `
      1.支持原生CSS写法和驼峰写法 <br>
      2.按下CTRL-Z以返回上一步<br>
      3.输入完成自动提交<br>
      4.默认单位为px
`,
      enableAdvancedInlineSetting: false
    };
  },
  components: {
    SPEffects,
    // SPDisplay,
    SPCssBox,
    SPBorder,
    SPPosition,
    SPOverflow,
    WAccordion,
    SPHover,
    DiyClassName,
    NewFontStyle,
    NewBackground,
    CSSSelector,
    PanelStateCssEditor,
    StyleTemplagePanel,
    CssEditorList
  },
  provide() {
    return {
      dom: this.dom,
      showPanelName: this.showPanelName,
      stylePanel: this
    };
  },
  computed: {
    style: {
      get() {
        return this.stylePanelState.styles;
      },
      set(value) {
        this.stylePanelState.styles = value;
      }
    },
    stylePanelState() {
      return this.designer.stylePanelState;
    },
    dom: {
      get() {
        var _this$designer$render;
        return (_this$designer$render = this.designer.renderer.getRefByPath(this.compPath)) === null || _this$designer$render === void 0 ? void 0 : _this$designer$render.$el;
      }
    },
    styleSheets: {
      get() {
        // 如果删除了样式表，关联的样式名一并删除
        const sheet = this.designer.rootPagelet.styleSheets;
        return sheet || [];
      }
    },
    defaultHoverStyle: {
      get() {
        const hoverStyle = this.stylePanelState.getStylesBySelector({
          pseudo: '&:hover'
        });
        return hoverStyle;
      },
      set(value) {
        this.commitHoverStyle(value);
      }
    },
    // 现在已经是 undefined了
    cssGenerator: {
      get() {
        return this.designer.rootRenderer.ucCssGenerator;
      }
    },
    hoverStyleNameUUID: {
      get() {
        var _this$comp$styleSheet, _hoverStyleName$match;
        // 找到hover的私有样式名
        const hoverStyleName = (_this$comp$styleSheet = this.comp.styleSheetName) === null || _this$comp$styleSheet === void 0 ? void 0 : _this$comp$styleSheet.find(item => item.indexOf('uc-private') !== -1);
        return (hoverStyleName === null || hoverStyleName === void 0 || (_hoverStyleName$match = hoverStyleName.match(/uc-private-style-([0-9A-Za-z-]*)/)) === null || _hoverStyleName$match === void 0 ? void 0 : _hoverStyleName$match[1]) || getHashValue(uuidv4());
      }
    },
    compClassName: {
      get() {
        var _this$comp;
        return (_this$comp = this.comp) === null || _this$comp === void 0 ? void 0 : _this$comp.class;
      }
    }
  },
  methods: {
    childrenCommitStyle(newStyle) {
      this.changeStyle({
        ...this.style,
        ...newStyle
      });
    },
    childrenFullCommitStyle(style) {
      this.changeStyle({
        ...style
      });
    },
    /**
     * 提交样式修改
     */
    commitStyle() {
      const style = {
        ...this.style
      };
      // 提交之前检查是否非零，并加上单位
      this.designer.modifyComp(this.compPath, c => {
        const mpStyleObj = getStyleAfterUnitCompletion(style);
        const styleMail = pickBy({
          ...style,
          ...mpStyleObj
        }, v => v !== undefined && v !== ''); // 0值是允许的

        if (Object.keys(styleMail).length === 0) {
          if ('style' in c) this.$delete(c, 'style');
        } else {
          c.style = styleMail;
        }
      });
    },
    deleteStyleSheet(id) {
      this.cssGenerator.deleteStyle(id);
      this.commitToPagelet('styleSheets', this.cssGenerator.getSheets());
    },
    chooseStyleSheet(styleSheetId) {
      var _this$styleSheets;
      const target = (_this$styleSheets = this.styleSheets) === null || _this$styleSheets === void 0 ? void 0 : _this$styleSheets.find(item => item.id === styleSheetId);
      if (target) {
        this.mountStyleSheet(target);
      }
    },
    removeStyleFromComp(id) {
      const className = `uc-public-style-${id}`;
      const preStyleSheetName = [...this.comp.styleSheetName];
      const idIndex = preStyleSheetName.indexOf(id);
      if (idIndex !== -1) {
        preStyleSheetName[idIndex] = null;
        this.commitToComp('styleSheetName', preStyleSheetName.filter(item => item));
      }
      const preClass = this.comp.class;
      const classIndex = preClass.indexOf(className);
      if (classIndex !== -1) {
        const newClass = preClass.replace(className, '');
        this.commitToComp('class', newClass);
      }
    },
    commitToComp(field, payload) {
      this.designer.modifyComp(this.compPath, c => {
        if (isEmpty(c[field]) && isEmpty(payload)) {
          return false;
        }
        c[field] = payload;
      });
    },
    commitToPagelet(field, payload) {
      if (!field) return void 0;
      this.$set(this.designer.rootPagelet, field, payload);
      this.designer.uc.notifyPageletsChange(0);
    },
    commitHoverStyle(hoverStyleObj) {
      this.designer.stylePanelState.setStylesBySelector(hoverStyleObj, {
        pseudo: '&:hover'
      });
    },
    submitCurrentPublicStyleSheet(styleSheetName) {
      const payload = {
        id: getHashValue(uuidv4()),
        name: styleSheetName,
        hoverStyle: this.hoverStyle,
        staticStyle: this.style
      };
      this.submitPublicStyleSheet(payload, true);
    },
    /**
     * @param styleSheetName 样式表中文名，如果相同将会替换内容
     * @param stylePayload 样式表的内容，默认从this中取
     */
    submitPublicStyleSheet(stylePayload, mountCurrent) {
      const {
        hoverStyle,
        staticStyle: style,
        name,
        id
      } = stylePayload;
      const fullId = `uc-public-style-${id}`;
      const staticStyle = {
        ...style,
        ...getStyleAfterUnitCompletion(style)
      };
      const styleDetail = {
        id,
        className: fullId,
        style: {
          static: {
            ...staticStyle
          },
          hover: {
            ...hoverStyle
          }
        },
        type: UCStyleSheetType.Public,
        tagDomId: fullId,
        cnName: name
      };
      if (isEmpty(staticStyle)) {
        delete styleDetail.style.static;
      }
      if (isEmpty(hoverStyle)) {
        delete styleDetail.style.hover;
      }
      this.commitToCssGenerator(styleDetail);
      if (mountCurrent) {
        this.mountStyleSheet(styleDetail);
      }
    },
    // 废弃
    submitPrivateStyleSheet(styleObj, isHoverPreview) {
      this.hoverStyle = {
        ...styleObj
      };
      const id = this.hoverStyleNameUUID;
      const fullId = `uc-private-style-${id}`;
      const styleSheetDetail = {
        id: fullId,
        className: fullId,
        style: {
          hover: {
            ...styleObj
          },
          static: isHoverPreview ? {
            ...styleObj
          } : {}
        },
        type: UCStyleSheetType.Private,
        tagDomId: fullId
      };
      this.commitToCssGenerator(styleSheetDetail);
      this.mountStyleSheet(styleSheetDetail);
    },
    commitToCssGenerator(styleDetail) {
      // TODO 重构
      // this.cssGenerator.patchStyle(styleDetail);
      // this.commitToPagelet('styleSheets', this.cssGenerator?.getSheets());
    },
    mountStyleSheet(sheetDetail) {
      if (validStyleSheet(sheetDetail)) {
        const {
          className,
          id
        } = sheetDetail;
        if (!this.comp.class || this.comp.class.indexOf(className) === -1) {
          this.commitToComp('class', `${this.comp.class ? `${this.comp.class} ` : ''}${className}`);
        }
        if (!this.comp.styleSheetName || this.comp.styleSheetName.indexOf(id) === -1) {
          var _this$comp$styleSheet2;
          this.commitToComp('styleSheetName', ((_this$comp$styleSheet2 = this.comp.styleSheetName) === null || _this$comp$styleSheet2 === void 0 ? void 0 : _this$comp$styleSheet2.concat(id)) || [id]);
        }
      }
    },
    highlightCssSelector() {
      var _this$$refs$cssSelect;
      highlightRect((_this$$refs$cssSelect = this.$refs.cssSelector) === null || _this$$refs$cssSelect === void 0 ? void 0 : _this$$refs$cssSelect.$el.getBoundingClientRect());
    },
    hoverPreviewSwitchHandler(flag) {
      // hover切换现在只是切选择器而已
      this.designer.stylePanelState.currentPseudoClass = flag ? '&:hover' : '';
      this.highlightCssSelector();
    },
    changeStyle(style) {
      this.style = {
        ...style
      };
    },
    addCompClassName(value) {
      if (typeof value === 'string') {
        const internalClassNameString = getInternalClassNames(this.compClassName);
        const finalClassString = `${internalClassNameString} ${value}`;
        this.commitToComp('class', finalClassString);
      }
    }
  },
  created() {
    vueLinkStorageWithDefaultObjectValue(this, 'stylePanel', 'panelExpanded', localStorage, this.panelExpanded);
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    key: _vm.compPath,
    staticClass: "ucdProps_propsForm ucd-stylePanel-wrapper"
  }, [_c("WAccordion", {
    staticClass: "ucdProps-cssSelector-accordion",
    attrs: {
      title: "自定义CSS"
    },
    model: {
      value: _vm.panelExpanded.css,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "css", $$v);
      },
      expression: "panelExpanded.css"
    }
  }, [_c("CSSSelector", {
    ref: "cssSelector",
    attrs: {
      slot: "title"
    },
    on: {
      changeExpanded: function () {
        return _vm.panelExpanded.css = true;
      }
    },
    slot: "title",
    model: {
      value: _vm.enableAdvancedInlineSetting,
      callback: function ($$v) {
        _vm.enableAdvancedInlineSetting = $$v;
      },
      expression: "enableAdvancedInlineSetting"
    }
  }), _vm._v(" "), _c("CssEditorList", {
    attrs: {
      "enable-advanced-inline-setting": _vm.enableAdvancedInlineSetting
    },
    on: {
      highlightSelector: _vm.highlightCssSelector
    }
  })], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "尺寸"
    },
    model: {
      value: _vm.panelExpanded.layoutBox,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "layoutBox", $$v);
      },
      expression: "panelExpanded.layoutBox"
    }
  }, [_c("SPCssBox")], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "文字"
    },
    model: {
      value: _vm.panelExpanded.fontStyle,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "fontStyle", $$v);
      },
      expression: "panelExpanded.fontStyle"
    }
  }, [_c("NewFontStyle")], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "背景"
    },
    model: {
      value: _vm.panelExpanded.background,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "background", $$v);
      },
      expression: "panelExpanded.background"
    }
  }, [_c("NewBackground")], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "边框与阴影"
    },
    model: {
      value: _vm.panelExpanded.detail,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "detail", $$v);
      },
      expression: "panelExpanded.detail"
    }
  }, [_c("SPBorder")], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "效果"
    },
    model: {
      value: _vm.panelExpanded.effects,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "effects", $$v);
      },
      expression: "panelExpanded.effects"
    }
  }, [_c("SPEffects")], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "布局 & 排布"
    },
    model: {
      value: _vm.panelExpanded.layout,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "layout", $$v);
      },
      expression: "panelExpanded.layout"
    }
  }, [_c("SPOverflow"), _vm._v(" "), _c("SPPosition")], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "鼠标悬浮时"
    },
    model: {
      value: _vm.panelExpanded.hover,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "hover", $$v);
      },
      expression: "panelExpanded.hover"
    }
  }, [_c("SPHover", {
    on: {
      hoverpreviewswitch: _vm.hoverPreviewSwitchHandler
    }
  })], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "样式模板"
    },
    model: {
      value: _vm.panelExpanded.preference,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "preference", $$v);
      },
      expression: "panelExpanded.preference"
    }
  }, [_c("StyleTemplagePanel")], 1), _vm._v(" "), _c("WAccordion", {
    attrs: {
      title: "高级选项"
    },
    model: {
      value: _vm.panelExpanded.advanced,
      callback: function ($$v) {
        _vm.$set(_vm.panelExpanded, "advanced", $$v);
      },
      expression: "panelExpanded.advanced"
    }
  }, [_c("DiyClassName", {
    attrs: {
      "prime-class": _vm.compClassName
    },
    on: {
      commit: _vm.addCompClassName
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);